module.exports = __webpack_public_path__ + "static/logo-fortress-new-269c42767adeb096e451a79d896a15fc.png";